module.exports = __webpack_public_path__ + "img/normal-buy.896b3c4f.png";